import { h } from 'preact'
import { useState, useEffect } from 'preact/hooks'
import { tagParser, safeHtml } from '../../js/modules/utilities.js'
import { attributesAnalytics } from '../../js/modules/component'

export const Marketplace = ({ title, title_description, description, images = {}, items = [] }) => {
   const [isMobile, setIsMobile] = useState(() => typeof window !== 'undefined' && window.matchMedia('(max-width: 735px)').matches)

   useEffect(() => {
      const mq = window.matchMedia('(max-width: 735px)')
      const handler = (e) => setIsMobile(e.matches)
      mq.addEventListener('change', handler)
      return () => mq.removeEventListener('change', handler)
   }, [])

   const backgroundImage = isMobile ? (images.mobile ? `url(${images.mobile})` : 'none') : images.desktop ? `url(${images.desktop})` : 'none'

   return (
      <div class="mt-1 mt-xl-3 mb-2 marketplace">
         <div class="container-fluid">
            <div class="row">
               <div class="col-12">
                  <h2 class="no-signature title mw-100 mb-1" dangerouslySetInnerHTML={{ __html: safeHtml(tagParser(title)) }} />

                  <div class="bg-gray2 wrapper pt-2" style={{ backgroundImage }}>
                     <div class="description">
                        {title_description && <h3 class="h3 mb-0 text-primary" dangerouslySetInnerHTML={{ __html: safeHtml(tagParser(title_description)) }} />}
                        {description && <p class="lead mb-0">{description}</p>}
                     </div>

                     {items.length > 0 && (
                        <div class="marketplace-categories">
                           <ul class="list-unstyled mb-0 marketplace-categories-list">
                              {items.map((item, index) => (
                                 <li class="marketplace-item d-flex">
                                    <a
                                       href={item.URL}
                                       class="marketplace-item-link d-flex flex-column align-items-center justify-content-start focus-visible-dark no-decoration w-100 h-100"
                                       {...attributesAnalytics(item.analytics)}
                                    >
                                       <span class={`icon ${item.icon} marketplace-item-icon`} aria-hidden="true"></span>
                                       <span class="marketplace-item-label" dangerouslySetInnerHTML={{ __html: safeHtml(tagParser(item.title)) }}></span>
                                    </a>
                                 </li>
                              ))}
                           </ul>
                        </div>
                     )}
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}
